// ZonesPage - Wrapper component for global zones view
// Created as part of ENG2-1701: Update Routing and Page Integration

import React from 'react'
import { Box } from '@mui/material'
import { Topbar } from 'layouts'
import GlobalZones from './global-zones'

const ZonesPage: React.FC = () => {
  return (
    <>
      <Topbar title="Zones" />
      <Box sx={{ p: 3 }}>
        <GlobalZones />
      </Box>
    </>
  )
}

export { ZonesPage }
export default ZonesPage
